import { headerLinkListStyles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        padding: 0;
    `,
};

headerLinkListStyles.link = {
    typographyProps: {
        variant: "headerTertiary",
        css: css`
            margin: 0 9px 0 9px;
            font-size: 14px;
            text-transform: capitalize;
            display: inline-block;
            &&& {
                color: ${getColor("text.main")};
            }
        `,
    },
};
